import { FaFacebook, FaInstagram, FaYoutube, FaPatreon } from "react-icons/fa";

const SocialNetworkLinks = () => {
  return (
    <div className="flex space-x-4 md:space-x-6 text-lg md:text-xl text-gray-400 justify-center md:justify-start">
      <a
        href="https://www.facebook.com/profile.php?id=100063796410255"
        target="_blank"
        rel="noreferrer"
        aria-label="Facebook"
        className="transition-colors duration-200 hover:text-[#1877F2]"
      >
        <FaFacebook />
      </a>
      <a
        href="https://www.instagram.com/awcgarejelebi/"
        target="_blank"
        rel="noreferrer"
        aria-label="Instagram"
        className="transition-colors duration-200 hover:text-[#E4405F]"
      >
        <FaInstagram />
      </a>
      <a
        href="https://www.youtube.com/@awcgarejelebi"
        target="_blank"
        rel="noreferrer"
        aria-label="YouTube"
        className="transition-colors duration-200 hover:text-[#FF0000]"
      >
        <FaYoutube />

      </a>
      <a
        href="https://www.patreon.com/AWCGarejelebi"
        target="_blank"
        rel="noreferrer"
        aria-label="Patreon"
        className="transition-colors duration-200 hover:text-[#F96854]"
      >
        <FaPatreon />
      </a>
    </div>
  );
};

export default SocialNetworkLinks;
